export function getSubdomain(locale: string) {
  return locale === 'ru' ? 'ru.' : '';
}
export function generateBaseUrl(host: string, locale: string) {
  const normalizedLocale = getSubdomain(locale);
  return `https://${normalizedLocale}${host}`;
}
